import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"color":"white"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex justify-center" }, [
      _createElementVNode("p", { style: {"font-weight":"bolder"} }, "Création de compte entreprise")
    ], -1)),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "d-flex align-center justify-start" }, {
          default: _withCtx(() => [
            (_ctx.isUserStep && !_ctx.ended)
              ? (_openBlock(), _createBlock(_component_v_btn_back, {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getBack())),
                  class: "ml-8"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { class: "d-flex align-center justify-center" }, {
          default: _withCtx(() => [
            (_ctx.step_ != 5)
              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                  key: 0,
                  color: "primary",
                  height: "20",
                  rounded: "",
                  "model-value": (_ctx.step_ / 4) * 100
                }, {
                  default: _withCtx(({ value }) => [
                    _createElementVNode("strong", _hoisted_1, _toDisplayString(_ctx.step_ + 1) + " / 5", 1)
                  ]),
                  _: 1
                }, 8, ["model-value"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { class: "d-flex align-center justify-end" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              class: "button mr-8",
              rounded: "",
              elevation: "0",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validNextStep())),
              loading: _ctx.loading,
              size: "small",
              location: "end"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.actionButtonWording), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}